import { render, staticRenderFns } from "./pet-quote-info.vue?vue&type=template&id=6dda378a&scoped=true&"
import script from "./pet-quote-info.vue?vue&type=script&lang=js&"
export * from "./pet-quote-info.vue?vue&type=script&lang=js&"
import style0 from "./pet-quote-info.vue?vue&type=style&index=0&id=6dda378a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dda378a",
  null
  
)

export default component.exports